<p-wrapper
  *ngIf="showFormCollabContent && user"
  id="valider-collab"
  titleWrapper="Valider mon compte collaborateur"
>
  <div body class="px-5">
    <div *ngIf="showErrorMsg" class="alert alert-danger" role="alert">
      <span>{{ errorMsg }}</span>
    </div>

    <form accept-charset="UTF-8">
      <div class="row">
        <div class="col">
          <div class="mb-3">
            <label for="firstname" class="form-label">Prénom</label>
            <input
              type="text"
              class="form-control"
              id="firstname"
              name="firstname"
              [value]="user.prenom"
              disabled
            />
          </div>
        </div>
        <div class="col">
          <div class="mb-3">
            <label for="lastname" class="form-label">Nom</label>
            <input
              type="text"
              class="form-control"
              id="lastname"
              name="lastname"
              [value]="user.nom"
              disabled
            />
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <div class="mb-3">
            <label for="email" class="form-label">Email</label>
            <input
              type="email"
              class="form-control"
              id="email"
              name="email"
              [value]="utilisateurToValidate.email"
              disabled
            />
          </div>
        </div>
        <div class="col">
          <div class="mb-3">
            <label for="organisme" class="form-label">Code client</label>
            <input
              type="email"
              class="form-control"
              id="organisme"
              name="organisme"
              [value]="crpcen"
              disabled
            />
          </div>
        </div>
      </div>

      <p-separator />

      <div class="my-3">
        <p-input
          [formControl]="this.validationForm.controls.login"
          id="username"
          type="text"
          label="Identifiant"
          name="username"
          description="Entrer votre identifiant"
          [disabled]="utilisateurToValidate.type === cbType"
          class="mt-4"
        ></p-input>

        <div
          *ngIf="
            validationForm.controls.login.touched &&
            validationForm.controls.login.errors
          "
          class="text-danger my-2"
        >
          <span
            *ngIf="validationForm.controls.login.errors['LOGIN.MAX_LENGTH']"
          >
            {{ validationForm.controls.login.errors["LOGIN.MAX_LENGTH"] }}
          </span>
          <span
            *ngIf="validationForm.controls.login.errors['LOGIN.INVALID_FORMAT']"
          >
            {{ validationForm.controls.login.errors["LOGIN.INVALID_FORMAT"] }}
          </span>
        </div>

        <p-input
          (input)="passwordChanges()"
          [formControl]="this.validationForm.controls.password1"
          id="password1"
          [type]="passwordInputType"
          label="Mot de passe"
          name="password1"
          autocomplete="new-password"
          [withRightIcon]="true"
        >
          <span rightIcon (click)="showPassword()">
            <i-feather *ngIf="!isPasswordDisplayed" name="eye"></i-feather>
            <i-feather *ngIf="isPasswordDisplayed" name="eye-off"></i-feather>
          </span>
        </p-input>

        <div class="container validator">
          <div class="row">
            <div class="col" [ngClass]="styleValidatorNumber">
              &#x2022; <small>Au moins un chiffre</small>
            </div>
            <div class="col" [ngClass]="styleValidatorUppercase">
              &#x2022; <small>Au moins une majuscule</small>
            </div>
          </div>
          <div class="row">
            <div class="col" [ngClass]="styleValidatorLowercase">
              &#x2022; <small>Au moins une minuscule</small>
            </div>
            <div class="col" [ngClass]="styleValidatorSize">
              &#x2022; <small>Au moins 12 caractères</small>
            </div>
          </div>
          <div class="row">
            <div class="col" [ngClass]="styleValidatorSpecial">
              &#x2022; <small>Au moins un caractère spécial</small>
            </div>
          </div>
        </div>

        <p-input
          [formControl]="this.validationForm.controls.password2"
          id="password2"
          [type]="confirmPasswordInputType"
          label="Confirmer mot de passe"
          name="password2"
          description="Confirmer votre mot de passe"
          errorMessage="Les 2 mots de passe doivent être identiques"
          autocomplete="new-password"
          [withRightIcon]="true"
        >
          <span rightIcon (click)="showConfirmPassword()">
            <i-feather
              *ngIf="!isConfirmPasswordDisplayed"
              name="eye"
            ></i-feather>
            <i-feather
              *ngIf="isConfirmPasswordDisplayed"
              name="eye-off"
            ></i-feather>
          </span>
        </p-input>
      </div>
      <div class="d-flex justify-content-center mt-4">
        <p-button
          id="btn-confirmer"
          label="Confirmer"
          [width]="100"
          [loading]="loading"
          [disabled]="!validationForm.valid"
          class="col-5"
          (click)="onValidateCollab()"
        ></p-button>
      </div>
    </form>
  </div>
</p-wrapper>

<app-success
  *ngIf="showSuccessComp"
  [message]="'Ce compte a bien été créé !'"
></app-success>

<app-fail
  *ngIf="showFailComp"
  [message]="
    'Un problème a été rencontré lors de la validation de votre compte !'
  "
></app-fail>
